<template>
  <section class="pc-panel tm">
    <header class="pc-panel__head">
      <span class="pc-panel__bar"></span>
      <h2 class="pc-panel__title">抬头管理</h2>
    </header>

    <div class="tm-section">
      <div class="tm-head">
        <h3 class="tm-head__title">发票抬头信息</h3>
        <el-button
          class="client-eval-add-btn"
          icon="el-icon-plus"
          type="primary"
          size="small"
          @click="openAdd"
        >
          添加抬头
        </el-button>
      </div>
      <div class="table tm-table">
        <el-table
          v-loading="loading"
          :data="titleList"
          border
          size="small"
          style="width: 100%"
        >
          <el-table-column label="抬头类型" width="90" align="center">
            <template slot-scope="scope">
              {{ invoiceTitleTypeText(scope.row.invoiceType) }}
            </template>
          </el-table-column>
          <el-table-column label="抬头名称" min-width="180">
            <template slot-scope="scope">
              <span v-if="isDefault(scope.row)" class="tm-default">默认</span>
              <span>{{ scope.row.title || '—' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="taxNo" label="发票税号" min-width="160">
            <template slot-scope="scope">
              {{ scope.row.taxNo || '—' }}
            </template>
          </el-table-column>
          <el-table-column prop="address" label="注册地址" min-width="200">
            <template slot-scope="scope">
              {{ scope.row.address || '—' }}
            </template>
          </el-table-column>
          <el-table-column prop="phone" label="联系电话" min-width="130">
            <template slot-scope="scope">
              {{ maskPhone(scope.row.phone) }}
            </template>
          </el-table-column>
          <el-table-column prop="bankName" label="开户行" min-width="160">
            <template slot-scope="scope">
              {{ scope.row.bankName || '—' }}
            </template>
          </el-table-column>
          <el-table-column prop="bankAccount" label="银行账号" min-width="160">
            <template slot-scope="scope">
              {{ maskBankAccount(scope.row.bankAccount) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150" align="center" fixed="right">
            <template slot-scope="scope">
              <div class="tm-actions">
                <span class="tm-link" @click="openEdit(scope.row)">编辑</span>
                <span class="tm-link-divider"></span>
                <span class="tm-link" @click="toggleDefault(scope.row)">
                  {{ isDefault(scope.row) ? '取消默认' : '设为默认' }}
                </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="删除" width="70" align="center" fixed="right">
            <template slot-scope="scope">
              <i
                class="iconfont icon-shanchu tm-del"
                title="删除"
                @click="onDelete(scope.row)"
              ></i>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div class="tm-section">
      <div class="tm-head">
        <h3 class="tm-head__title">收票邮箱</h3>
        <el-button
          class="client-eval-add-btn"
          icon="el-icon-plus"
          type="primary"
          size="small"
          @click="onEmailAdd"
        >
          添加邮箱
        </el-button>
      </div>
      <div class="table tm-table">
        <el-table
          v-loading="emailLoading"
          :data="emailList"
          border
          size="small"
          style="width: 100%"
        >
          <el-table-column label="邮箱" min-width="220">
            <template slot-scope="scope">
              <span v-if="isEmailDefault(scope.row)" class="tm-default">默认</span>
              <span>{{ scope.row.email || '—' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150" align="center">
            <template slot-scope="scope">
              <div class="tm-actions">
                <span class="tm-link" @click="onEmailEdit(scope.row)">编辑</span>
                <span class="tm-link-divider"></span>
                <span class="tm-link" @click="onEmailDefault(scope.row)">
                  {{ isEmailDefault(scope.row) ? '取消默认' : '设为默认' }}
                </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="删除" width="70" align="center">
            <template slot-scope="scope">
              <i
                class="iconfont icon-shanchu tm-del"
                title="删除"
                @click="onEmailDelete(scope.row)"
              ></i>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <InvoiceTitleDialog
      :visible="dialogVisible"
      :edit-data="editItem"
      @close="closeDialog"
      @success="onDialogSuccess"
    />
    <InvoiceEmailDialog
      :visible="emailDialogVisible"
      :edit-data="emailEditItem"
      @close="closeEmailDialog"
      @success="onEmailDialogSuccess"
    />
    <DeleteConfirmDialog
      :visible.sync="deleteDialogVisible"
      :message="deleteMessage"
      :loading="deleteLoading"
      @cancel="closeDeleteDialog"
      @confirm="confirmDelete"
    />
  </section>
</template>

<script>
/** 抬头管理：发票抬头列表 + 收票邮箱 */
import '@/assets/icon1/iconfont.css';
import {
  fetchInvoiceTitleList,
  deleteInvoiceTitle,
  saveInvoiceTitle,
  fetchEmailList,
  saveEmail,
  deleteEmail,
} from './api';
import { invoiceTitleTypeText } from '../../config';
import InvoiceTitleDialog from './InvoiceTitleDialog.vue';
import InvoiceEmailDialog from './InvoiceEmailDialog.vue';
import DeleteConfirmDialog from './DeleteConfirmDialog.vue';

export default {
  name: 'PcTitleManage',
  components: { InvoiceTitleDialog, InvoiceEmailDialog, DeleteConfirmDialog },
  data() {
    return {
      titleList: [],
      emailList: [],
      loading: false,
      emailLoading: false,
      dialogVisible: false,
      editItem: null,
      emailDialogVisible: false,
      emailEditItem: null,
      deleteDialogVisible: false,
      deleteMessage: '',
      deleteLoading: false,
      deleteTarget: null,
      deleteType: '',
    };
  },
  mounted() {
    this.loadList();
    this.loadEmailList();
  },
  methods: {
    invoiceTitleTypeText,
    /** 列表展示联系电话，手机号中间4位脱敏 */
    maskPhone(phone) {
      const str = String(phone || '').trim();
      if (!str) return '—';
      if (/^1\d{10}$/.test(str)) {
        return `${str.slice(0, 3)}****${str.slice(7)}`;
      }
      if (str.length <= 4) return '*'.repeat(str.length);
      if (str.length <= 7) {
        return `${str.slice(0, 2)}${'*'.repeat(str.length - 4)}${str.slice(-2)}`;
      }
      return `${str.slice(0, 3)}${'*'.repeat(str.length - 7)}${str.slice(-4)}`;
    },
    /** 列表展示银行账号，保留前4后4，中间脱敏 */
    maskBankAccount(account) {
      const str = String(account || '').trim();
      if (!str) return '—';
      if (str.length <= 8) {
        const maskLen = Math.max(str.length - 4, 2);
        return `${str.slice(0, 2)}${'*'.repeat(maskLen)}${str.slice(-2)}`;
      }
      return `${str.slice(0, 4)}${'*'.repeat(str.length - 8)}${str.slice(-4)}`;
    },
    isDefault(row) {
      return Number(row.isDefault) === 1;
    },
    loadList() {
      this.loading = true;
      fetchInvoiceTitleList()
        .then((data) => {
          this.titleList = data || [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    openAdd() {
      this.editItem = null;
      this.dialogVisible = true;
    },
    openEdit(row) {
      this.editItem = row;
      this.dialogVisible = true;
    },
    closeDialog() {
      this.dialogVisible = false;
      this.editItem = null;
    },
    onDialogSuccess(payload) {
      const isEdit = payload && payload.mode === 'edit';
      this.$message.success(isEdit ? '修改成功' : '添加成功');
      this.loadList();
    },
    toggleDefault(row) {
      const next = this.isDefault(row) ? 0 : 1;
      saveInvoiceTitle({
        ...this.rowToPayload(row),
        isDefault: next,
      })
        .then(() => {
          this.$message.success(next ? '已设为默认' : '已取消默认');
          this.loadList();
        })
        .catch((err) => {
          this.$message.error((err && err.message) || '操作失败');
        });
    },
    rowToPayload(row) {
      const invoiceType = Number(row.invoiceType) === 0 ? 0 : 1;
      const payload = {
        id: row.id,
        invoiceType,
        title: row.title,
      };
      if (invoiceType === 1) {
        payload.taxNo = row.taxNo || '';
        payload.address = row.address || '';
        payload.phone = row.phone || '';
        payload.bankName = row.bankName || '';
        payload.bankAccount = row.bankAccount || '';
      } else {
        payload.taxNo = '';
        payload.address = '';
        payload.phone = '';
        payload.bankName = '';
        payload.bankAccount = '';
      }
      return payload;
    },
    openDeleteDialog(row, type, message) {
      this.deleteTarget = row;
      this.deleteType = type;
      this.deleteMessage = message;
      this.deleteDialogVisible = true;
    },
    closeDeleteDialog() {
      if (this.deleteLoading) return;
      this.deleteDialogVisible = false;
      this.deleteTarget = null;
      this.deleteType = '';
      this.deleteMessage = '';
    },
    confirmDelete() {
      const { deleteTarget, deleteType } = this;
      if (!deleteTarget || !deleteType) return;
      this.deleteLoading = true;
      const request =
        deleteType === 'title'
          ? deleteInvoiceTitle(deleteTarget.id)
          : deleteEmail(deleteTarget.id);
      request
        .then(() => {
          this.$message.success('删除成功');
          if (deleteType === 'title') {
            this.loadList();
          } else {
            this.loadEmailList();
          }
          this.deleteLoading = false;
          this.closeDeleteDialog();
        })
        .catch((err) => {
          this.deleteLoading = false;
          this.$message.error((err && err.message) || '删除失败');
        });
    },
    onDelete(row) {
      const name = row.title || '';
      this.openDeleteDialog(row, 'title', `确认删除抬头“${name}”吗？`);
    },
    isEmailDefault(row) {
      return Number(row.isDefault) === 1;
    },
    loadEmailList() {
      this.emailLoading = true;
      fetchEmailList()
        .then((data) => {
          this.emailList = data || [];
        })
        .finally(() => {
          this.emailLoading = false;
        });
    },
    onEmailAdd() {
      this.emailEditItem = null;
      this.emailDialogVisible = true;
    },
    onEmailEdit(row) {
      this.emailEditItem = row;
      this.emailDialogVisible = true;
    },
    closeEmailDialog() {
      this.emailDialogVisible = false;
      this.emailEditItem = null;
    },
    onEmailDialogSuccess(payload) {
      const isEdit = payload && payload.mode === 'edit';
      this.$message.success(isEdit ? '修改成功' : '添加成功');
      this.loadEmailList();
    },
    onEmailDefault(row) {
      const next = this.isEmailDefault(row) ? 0 : 1;
      saveEmail({
        id: row.id,
        email: row.email || '',
        isDefault: next,
      })
        .then(() => {
          this.$message.success(next ? '已设为默认' : '已取消默认');
          this.loadEmailList();
        })
        .catch((err) => {
          this.$message.error((err && err.message) || '操作失败');
        });
    },
    onEmailDelete(row) {
      const email = row.email || '';
      this.openDeleteDialog(row, 'email', `确认删除邮箱“${email}”吗？`);
    },
  },
};
</script>

<style scoped src="./style.css"></style>



// WEBPACK FOOTER //
// src/view/client/personal-center/panels/TitleManage/index.vue